export default __webpack_public_path__ + "72ba4406d523f30a99054cc43ac9821a.png";